import { Link } from "react-router-dom";
import { NovaOrb } from "../NovaOrb";

export const MeetNovaSection = () => (
  <section className="py-24 md:py-32" data-testid="meet-nova-section">
    <div className="max-w-md mx-auto px-6 sm:px-10 flex flex-col items-center text-center">
      <NovaOrb size={140} />
      <p className="font-display italic text-2xl sm:text-3xl text-kaizen-text mt-8 leading-relaxed" data-testid="meet-nova-copy">
        Nova is your adaptive fitness companion. She never lectures. She'll never say "you missed your workout."
        She says: "I've adjusted today's plan."
      </p>
      <p className="text-xs uppercase tracking-widest text-kaizen-dim2 mt-8" data-testid="meet-nova-research-line">
        Built from real research — 19 surveys, 5 interviews with people who quit.
      </p>
      <Link
        to="/signup"
        data-testid="meet-nova-cta"
        className="glow-cta mt-8 bg-kaizen-violet text-[#140A24] text-sm font-semibold px-7 py-3.5 rounded-full hover:scale-[1.02] transition-transform duration-300"
      >
        Meet Nova →
      </Link>
    </div>
  </section>
);
